function getStore() {
  const s = require('../store').default
  return s
}

export const cases = [
  { case_id: 1, title: '技术骨干因晋升失败欲离职，通过专项培养计划成功保留', behavior_tags: ['被忽视','无发展'], situation: '某高级开发工程师连续两年未获晋升，开始更新简历', actions: '为其制定技术专家发展路径，给予跨项目技术负责人角色', result: 1, outcome_description: '员工放弃离职，6个月后成功晋升为架构师', is_internal: 1 },
  { case_id: 2, title: '核心销售因薪资倒挂欲离职，通过薪酬调整成功保留', behavior_tags: ['薪资偏低'], situation: '发现其薪资比新入职同级员工低30%，已接触猎头', actions: '立即启动薪酬回顾，3个月内完成调薪至市场中位数', result: 1, outcome_description: '员工留任，业绩提升20%', is_internal: 1 }
]

export function getStoreCases() {
  const s = getStore()
  return s.state.cases && s.state.cases.cases && s.state.cases.cases.length
    ? s.state.cases.cases
    : cases
}
